// extracted by mini-css-extract-plugin
export default {"back":"Crew_back__kWh84","mainContainer":"Crew_mainContainer__7-ndS","crewContainer":"Crew_crewContainer__UHG2p","active":"Crew_active__BMXyu","imgBox":"Crew_imgBox__sfR4+"};